import { runStoreUpdate } from '@/utils/zustand';

// Must stay free of feature imports: feature stores register here so use-user-store never imports them (require cycle).
const listeners = new Set<() => void>();

export const registerLogoutListener = (listener: () => void) => {
    listeners.add(listener);
};

export const runLogoutListeners = () => {
    runStoreUpdate(() => {
        listeners.forEach(listener => listener());
    });
};
